import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'convertStringDate'
})
export class ConvertStringDatePipe implements PipeTransform {

  transform(value: string): Date {
    return new Date(value);
  }

}
